export default "__VITE_ASSET__DPlBbOQY__"